import {
  ConversationMessage,
  ChatRequest,
  ChatResponse,
  ContentBlock,
} from '../types/chat'

const CHAT_API_URL = '/api/chat'

/**
 * Convert ArrayBuffer to base64 string
 */
function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return btoa(binary)
}

/**
 * Create a document message with PDF content block
 */
export function createDocumentMessage(
  pdfData: ArrayBuffer,
  filename: string
): ConversationMessage {
  const base64Data = arrayBufferToBase64(pdfData)

  const content: ContentBlock[] = [
    {
      type: 'document',
      source: {
        type: 'base64',
        media_type: 'application/pdf',
        data: base64Data,
      },
    },
    {
      type: 'text',
      text: `Here is my CV from "${filename}". Please analyze it and help me improve it.`,
    },
  ]

  return {
    role: 'user',
    content,
  }
}

export async function sendChatMessage(
  messages: ConversationMessage[],
  memory: string,
  currentLatex: string,
  pageCount: number | null
): Promise<ChatResponse> {
  const request: ChatRequest = {
    messages,
    memory,
    currentLatex,
    pageCount,
  }

  const response = await fetch(CHAT_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(
      (errorData as { error?: string }).error ||
        `Request failed: ${response.status}`
    )
  }

  return response.json()
}
